
<template>
    <div class="evadetail-content">
        <div class="evadetail" :class="{'change-evadetail': changeFlag}">
            <div class="namedate">
                <img :src="productComment.accountAvatar" alt="">
                <span class="name">{{productComment.accountNickName}}</span>
                <van-rate
                    v-model="productComment.quantity"
                    :size="14"
                    v-if="showRate"
                    :count="productComment.quantity"
                    color="#EE2E50"
                    readonly
                    />
            </div>
            <p :class="['evaword', {'isLimit': isLimit === true}]">{{productComment.content ? productComment.content : '此用户没有填写评价'}}</p>
            <div v-if="imgShow">
                <div class="imgs clearfix" v-if="productComment.commentImage">
                    <div class="imgs1" v-for="(img, index) in productComment.commentImage.split(',')" :key="index">
                        <div @click="imgshowFun(index)" :style="{backgroundImage: 'url('+img+')'}" class="zoomImage"></div>
                    </div>
                </div>
                <div v-if="productComment.replyContent" class="['color', 'reply', {'isLimit': isLimit === true}]">商家回复：{{productComment.replyContent}}</div>
            </div>
            <div class="bottom">
                <div class="date-type-wrapper">
                    <span class="date">{{productComment.commentDate}}</span>
                </div>
                <div class="color sku">{{productComment.specificationValue}}</div>
            </div>
            <!-- <div class="color">{{productComment.specificationValue}}</div> -->
        </div>
        <van-image-preview
            v-model="show"
            :images="images"
            @change="onChange"
            :start-position='index'
            ref="preview"
            >
        </van-image-preview>
    </div>
</template>
<script>
export default {
    name: 'login',
    props: ['productComment', 'productId', 'evabuttonFlag', 'imgShow', 'changeFlag', 'showRate', 'isLimit'],
    data() {
        return {
            show: false,
            index: 0,
            images: this.productComment.commentImage.split(',')
        };
    },
    methods: {
        goevaluation(item) {
            this.esvOpenPage({
                name: 'OPEvaluation',
                params: { goodsId: item }
            });
        },
        imgshowFun(index) {
            this.index = index;
            this.show = true;
        },
        onChange(index) {
            this.index = index;
        }
    }
};
</script>
<style  lang="scss" scoped>
/* 商品评价 */
.evadetail-content {
    background: #fff;
}
.change-evadetail {
    margin-left: 12px;
    border-bottom: 1px solid #E3E2E2;
}
.evadetail {
    padding: 12px;
    background-color: #fff;
    .namedate {
        height: 24px;
        line-height: 24px;
        margin-bottom: 10px;
        color: #999;
        font-size: 14px;
        display: flex;
        justify-content: start;
        align-items: center;
        img {
            width: 24px;
            height: 24px;
            float: left;
        }
        .name {
            width: 75px;
            display: inline-block;
            float: left;
            margin-left: 10px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            flex: 1;
        }
        .date {
            flex: 1;
            text-align: right;
        }
    }
    .bottom {
        display: flex;
        align-items: center;
        margin-top: 6px;
        .date-type-wrapper {
            margin-right: 15px;
            min-width: 100px;
        }
        .sku {
            color: #999;
            font-size: 12px;
            margin-top: 0;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
        }
    }
    .evaword {
        color: #414141;
        font-size: 12px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
    }
    .imgs1 {
        width: 60px;
        height: 60px;
        float: left;
        margin: 4px 8px 0 0;
        font-size: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        .zoomImage{
            width:100%;
            height:0;
            padding-bottom: 100%;
            overflow:hidden;
            background-position: center center;
            background-repeat: no-repeat;
            -webkit-background-size:cover;
            -moz-background-size:cover;
            background-size:cover;
        }
        // img {
        //     max-width: 100%;
        //     // max-height: 100%;
        //     width: auto;
        //     height: auto;
        // }
    }
    .color {
        color: #bebec5;
        font-size: 12px;
        margin-top: 4px;
        // overflow:hidden;
        // text-overflow:ellipsis;
        // white-space:nowrap;
    }
    .isLimit {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
}
.evabutton {
    margin: 0 auto;
    width: 110px;
    height: 28px;
    line-height: 28px;
    color: $primary-color;
    text-align: center;
    border: 1px solid $primary-color;
    border-radius: 14px;
}
</style>
